/**
 * @author: Claude
 * @date: 2026/03/24
 * @desc: FilterPresetSelect 组件演示
 */
import React from 'react';
import FilterPresetSelect from './index';

// 模拟筛选器方案数据
const mockPresetOptions = [
  { value: 'preset1', text: '高收入游戏筛选方案' },
  { value: 'preset2', text: '休闲品类分析方案' },
  { value: 'preset3', text: '美国市场数据方案' },
  { value: 'preset4', text: '本周热门游戏方案' },
  { value: 'preset5', text: '收入增长TOP100方案' },
];

// 超过10条的方案数据
const manyPresetOptions = Array.from({ length: 15 }, (_, i) => ({
  value: `preset${i + 1}`,
  text: `筛选方案${i + 1}`,
}));

/**
 * 组件演示配置
 * 每个配置项对应文档页面中的一个演示场景
 */
export const demoConfig = [
  {
    title: '基础用法',
    description: '展示组件的基础使用方式',
    code: `<FilterPresetSelect
  options={[
    { value: 'preset1', text: '高收入游戏筛选方案' },
    { value: 'preset2', text: '休闲品类分析方案' },
    { value: 'preset3', text: '美国市场数据方案' },
  ]}
  onChange={(value) => console.log('选中方案:', value)}
/>`,
    element: (
      <FilterPresetSelect
        options={mockPresetOptions.slice(0, 3)}
        onChange={(value) => console.log('选中方案:', value)}
      />
    ),
  },
  {
    title: '支持删除方案',
    description: 'hover 选项时显示删除图标，点击后弹出确认弹窗',
    code: `<FilterPresetSelect
  options={presetOptions}
  onDelete={(value) => {
    console.log('删除方案:', value);
  }}
/>`,
    element: (
      <FilterPresetSelect
        options={mockPresetOptions.slice(0, 3)}
        onDelete={(value) => console.log('删除方案:', value)}
      />
    ),
  },
  {
    title: '超过最大显示数量',
    description: '当选项超过 maxDisplayCount(默认10) 时显示提示',
    code: `<FilterPresetSelect
  options={manyPresetOptions}
  maxDisplayCount={10}
/>`,
    element: (
      <FilterPresetSelect
        options={manyPresetOptions}
        maxDisplayCount={10}
        onChange={(value) => console.log('选中方案:', value)}
      />
    ),
  },
  {
    title: '自定义文案',
    description: '自定义占位符和删除确认弹窗文案',
    code: `<FilterPresetSelect
  options={presetOptions}
  placeholder="选择已保存的筛选方案"
  searchPlaceholder="输入关键字搜索"
  deleteConfirmTitle="确认删除"
  deleteConfirmDesc="删除后将无法恢复，确定要删除此方案吗？"
  onDelete={(value) => handleDelete(value)}
/>`,
    element: (
      <FilterPresetSelect
        options={mockPresetOptions.slice(0, 3)}
        placeholder="选择已保存的筛选方案"
        searchPlaceholder="输入关键字搜索"
        deleteConfirmTitle="确认删除"
        deleteConfirmDesc="删除后将无法恢复，确定要删除此方案吗？"
        onDelete={(value) => console.log('删除方案:', value)}
      />
    ),
  },
];

export default demoConfig;